/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderCreateDto } from '../../models/shop-order-create-dto';
import { ShopOrderDto } from '../../models/shop-order-dto';

export interface ShopOrderControllerCreate$Params {
      body: ShopOrderCreateDto
}

export function shopOrderControllerCreate(http: HttpClient, rootUrl: string, params: ShopOrderControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDto>> {
  const rb = new RequestBuilder(rootUrl, shopOrderControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDto>;
    })
  );
}

shopOrderControllerCreate.PATH = '/api/shop-orders';
